var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "white",
    strokeOpacity: 0.57
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 14H25.6C26.37 14 27 14.63 27 15.4V23.8C27 24.57 26.37 25.2 25.6 25.2H14.4C13.63 25.2 13 24.57 13 23.8V15.4C13 14.63 13.63 14 14.4 14Z",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15.3999L20 20.2999L13 15.3999",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail1);
export default __webpack_public_path__ + "static/media/mail1.6fd08e32d673306e1fb3dc1179d3c32f.svg";
export { ForwardRef as ReactComponent };